import { render, staticRenderFns } from "./ItemDetailsModal.vue?vue&type=template&id=267e3d32&scoped=true"
import script from "./ItemDetailsModal.vue?vue&type=script&lang=js"
export * from "./ItemDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailsModal.vue?vue&type=style&index=0&id=267e3d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e3d32",
  null
  
)

export default component.exports